import * as React from 'react';
import { InputGroup } from 'react-bootstrap';
import { isEmpty } from 'lodash';

import { Component, I18NString } from '../../helpers/Utils';
import {
  IControlError,
  IControlSchema,
  ValidationResult,
} from '../../../core/Controls';
import { IDispatcher } from '../../helpers/Dispatcher';

import DateTime from '../components/Datetime';

import Field from '../components/Field';

import ErrorAlert from '../components/ErrorAlert';
import { filterIncorrectDate } from '../../helpers/filterIncorrectDate';

export interface ICalendarSchema extends IControlSchema {
  beginDate: I18NString;
  finishDate: I18NString;
  description: I18NString;
  notification: I18NString;
  value?: string;
  disabled?: boolean;
  currentDate: string;
  isMore?: boolean;
  isLess?: boolean;
  extra?: any;
  controlValue?: string;
}

interface Props {
  schema: ICalendarSchema;
  api: any;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
  controlValue?: any;
}

interface State {
  isOpen: boolean;
  isOpenNotification: boolean;
}

class Calendar extends Component<Props, State> {
  state = {
    isOpen: false,
    isOpenNotification: true,
  };

  componentDidMount() {
    const {
      schema: { value },
      error,
      controlValue,
    } = this.props;

    if (!isEmpty(value)) {
      this.props.dispatcher.onVisit(this.props.schema.id);
    }

    if (error) {
      return;
    }
    const validationResult = this.validationResult(value);
    this.props.dispatcher.setError(
      this.props.schema.id,
      value,
      validationResult && { message: validationResult.message },
      false,
    );
  }

  onChange = (date: string, _name: string) => {
    const validationResult = this.validationResult(date);
    let dateFixed = this.catchAndFixIncorrectDate(date);

    this.props.dispatcher.onBlur(
      this.props.schema.id,
      dateFixed,
      !validationResult,
      validationResult,
    );
  };

  /**
   * Если ввести пятизначный год - инпут даты упадёт
   * Предотвращаем это
   */
  catchAndFixIncorrectDate(date: string) {
    let dateUpdated = date;

    if (new Date(date).getFullYear() > 9999) {
      dateUpdated = filterIncorrectDate(date);
    }

    return dateUpdated;
  }

  onClick = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

  onOpenNotification = () =>
    this.setState(({ isOpenNotification }) => ({
      isOpenNotification: !isOpenNotification,
    }));

  // eslint-disable-next-line class-methods-use-this
  validationResult(_value: string): ValidationResult {
    return undefined;
  }

  render() {
    const {
      schema: { disabled, description, notification, value, extra },
      error,
      visited,
      controlValue,
    } = this.props;
    const errorText = visited && error && error.message;
    let status = 'default';

    if (errorText) {
      status = 'error';
    } else if (!isEmpty(value)) {
      status = 'success';
    }

    return (
      <Field {...this.props.schema} status={status}>
        {extra && extra.hint && (
          <div
            className="alert alert-info hint"
            dangerouslySetInnerHTML={{ __html: extra.hint }}
          />
        )}
        {/* @ts-ignore*/}
        <InputGroup style={{ width: '100%' }} id="calendar">
          <DateTime
            disabled={disabled}
            value={controlValue ? controlValue : value}
            ignoreTitle
            onChangeValue={(_value: string) => this.onChange(_value, 'begin')}
            onBlur={() => this.props.dispatcher.onVisit(this.props.schema.id)}
            valueType={extra?.valueType}
          />
          {notification && (
            // @ts-ignore
            <InputGroup.Addon
              onClick={this.onOpenNotification}
              bsClass="input-group-addon btn btn-default"
            >
              <span className="glyphicon glyphicon-info-sign" />
            </InputGroup.Addon>
          )}
          {description && (
            // @ts-ignore
            <InputGroup.Addon
              onClick={this.onClick}
              bsClass="input-group-addon btn btn-default"
            >
              <span className="glyphicon glyphicon-question-sign" />
            </InputGroup.Addon>
          )}
        </InputGroup>
        {notification && this.state.isOpenNotification && (
          <div
            className="alert alert-warning"
            role="alert"
            dangerouslySetInnerHTML={{ __html: this.tr(notification) }}
          />
        )}
        {description && this.state.isOpen && (
          <div
            className="alert alert-warning"
            role="alert"
            dangerouslySetInnerHTML={{ __html: this.tr(description) }}
          />
        )}
        <ErrorAlert errorMessage={errorText} />
      </Field>
    );
  }
}

export default Calendar;
